import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { HistoryTable } from './HistoryTable';
import { getBulkImportHistory } from '../../../actions/BulkImportActions';
import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  modal: {
    minWidth: '80%',
    zIndex: 1200,
  },
});

const BulkImportHistory = ({ setModalOpen, open, importEntityKey, isWorkflowMasterSetup }) => {
  const [isLoading, setLoading] = useState(true);
  const [importHistoryRows, setImportHistoryRows] = useState([]);

  const translateString = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    const getImportHistory = async () => {
      setLoading(true);
      const importHistoryData = await dispatch(
        getBulkImportHistory({ importEntityKey, isWorkflowMasterSetup })
      );
      setImportHistoryRows(importHistoryData);
      setLoading(false);
    };

    if (open) {
      getImportHistory();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Modal
      open={open}
      variant="default"
      onClose={() => setModalOpen(false)}
      title={translateString('Import History')}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
      hideButtons
    >
      <HistoryTable rows={importHistoryRows} isLoading={isLoading} />
    </Modal>
  );
};

export default BulkImportHistory;
